import React from "react";
import { useTranslation } from "react-i18next";
import "../../i18n";
import { TemporalSelectorModes } from "../../layouts/TemporalSelector/TemporalSelector";

export interface CustomTooltipProps {
	payload: any;
	label: string;
	active: boolean;
	payloadCurrentKey?: string;
	payloadPreviousKey?: string;
	colorCurrent?: string;
	colorPrevious?: string;
	mode?: TemporalSelectorModes;
}

const CustomTooltip: React.FC<CustomTooltipProps> = (props) => {
	const { t } = useTranslation();

	const currentLabel = props.mode === TemporalSelectorModes.week ? t("dashboard.dayCurrentWeek") : t("dashboard.dayCurrentMonth");
	const prevLabel = props.mode === TemporalSelectorModes.week ? t("dashboard.dayPreviousWeek") : t("dashboard.dayPreviousMonth");

	if (props.active) {
		return (
			<div style={{ backgroundColor: "white", padding: "10px" }}>
				<p>{`${props.payload[0].payload?.date ?? ""}`}</p>
				<p style={{ color: props.colorCurrent ? props.colorCurrent : "black" }}>{`${currentLabel}: ${
					props.payload[0].payload[props?.payloadCurrentKey ?? ""] ?? ""
				}`}</p>
				<p style={{ color: props.colorPrevious ? props.colorPrevious : "black" }}>{`${prevLabel}: ${
					props.payload[1].payload[props?.payloadPreviousKey ?? ""] ?? ""
				}`}</p>
			</div>
		);
	}

	return null;
};

export default CustomTooltip;
